module.exports = __webpack_public_path__ + "img/3f_r_bar2400.7013bc67.png";